/**
 * @description 抽奖
 */
import useRoomBaseServer from '../room/roombase.server';
import lotteryApi from '../../request/lottery';

import useMsgServer from '../common/msg.server';
import BaseServer from '../common/base.server';

// 前端缓存抽奖前置依赖数据,供多入口使用,减少请求
const lotteryTempCache = new Map()
// 临时缓存数据结构
class LotteryServer extends BaseServer {
  constructor(opt = {}) {
    super();
    const watchInitData = useRoomBaseServer().state.watchInitData;
    this.watchInitData = watchInitData;
    this._roomId = watchInitData.interact.room_id;
    this._webinarId = watchInitData.webinar.id;
    this.state = {
      iconVisible: false, // icon是否显示
      docVisible: false, // 小红点是否显示
      prizeTotal: 0, //奖品设置列表总数
      lotteryLiveId: '' // 抽奖列表中的id
    }
    this.listenMsg();
  }
  //对外暴露通知名称
  Events = {
    LOTTERY_PUSH: 'lottery_push', // 开始抽奖
    LOTTERY_RESULT_NOTICE: 'lottery_result_notice', // 抽奖结果
    LOTTERY_WIN: 'lottery_win', // 中奖
    LOTTERY_MISS: 'lottery_miss', // 未中奖
    LOTTERY_SUBMIT: 'lottery_submit', // 提交领奖
  };

  // 监听消息
  listenMsg() {
    useMsgServer().$onMsg('ROOM_MSG', msg => {
      switch (msg.data.event_type || msg.data.type) {
        //【分组创建/新增完成】
        case this.Events.LOTTERY_PUSH:
          // wap icon显示数量+1
          !this.state.iconVisible && this.changeIconShowNum(true)
          this.state.iconVisible = true
          this.state.docVisible = true
          this.$emit(this.Events.LOTTERY_PUSH, msg);
          window.bonreeJsBridge?.setCustomLog('message: lottery_push');
          break;
        case this.Events.LOTTERY_RESULT_NOTICE:
          // wap icon显示数量+1
          !this.state.iconVisible && this.changeIconShowNum(true)
          this.state.iconVisible = true
          this.$emit(this.Events.LOTTERY_RESULT_NOTICE, msg);
          window.bonreeJsBridge?.setCustomLog('message: lottery_result_notice');
          break;
      }
    });
  }

  // 获取列表
  getPrizeList(params) {
    return lotteryApi.getPrizeList({
      room_id: this._roomId,
      ...params
    });
  }

  // 初始化抽奖基础内容
  async initLotteryForm() {
    await this.getPrizeList();
    this.getQualifiedNum();
  }

  // 检查当前的抽奖状态
  checkLottery(lotteryId) {
    const params = {}
    if (lotteryId) params.lottery_id = lotteryId
    return lotteryApi.checkLottery(params);
  }

  // 参加口令抽奖
  joinLottery(lotteryId) {
    return lotteryApi.joinLottery({
      nickname: this.watchInitData?.join_info?.nickname,
      avatar: this.watchInitData?.join_info?.avatar,
      lottery_id: lotteryId,
      room_id: this._roomId
    }).then(res => {
      return res
    });
  }

  // 获取可参与抽奖用户
  queryQualifiedPerson(params) {
    return lotteryApi.queryQualifiedPerson({
      room_id: this._roomId,
      ...params
    });
  }

  // 重新初始化可参与抽奖用户
  updateLotteryUser() {
    const switch_id = useRoomBaseServer().state.watchInitData.switch.switch_id;
    return lotteryApi.updateUserStatus({
      switch_id
    });
  }

  // 开始抽奖
  pushLottery(params) {
    return lotteryApi.pushLottery({
      room_id: this._roomId,
      ...params
    });
  }

  // 开始抽奖
  endLottery(lotteryId) {
    return lotteryApi.endLottery({
      lottery_id: lotteryId,
      room_id: this._roomId
    });
  }

  // 检测是否已提交领奖信息
  getWinnerList(lotteryId, page = 1) {
    const limit = 50
    const pos = (page - 1) * limit
    return lotteryApi.getWinnerList({
      room_id: this._roomId,
      lottery_id: lotteryId,
      limit,
      pos
    });
  }

  // 检测是否已提交领奖信息
  checkLotteryResult(lotteryId = '') {
    return lotteryApi.checkLotteryResult({
      lottery_id: lotteryId
    });
  }

  // 获取表单信息
  getDrawPrizeInfo(lotteryId = '') {
    return lotteryApi.getDrawPrizeInfo({
      webinar_id: this._webinarId,
    });
  }

  // 获取表单信息
  acceptPrize(params) {
    return lotteryApi.acceptPrize({
      room_id: this._roomId,
      ...params
    });
  }
  // 获取中奖人信息
  getLotteryUserInfo() {
    return lotteryApi.getLotteryUserInfo({
      room_id: this._roomId
    });
  }

  // 获取中奖人信息
  getLotteryUserDetail(lotteryId = '') {
    return lotteryApi.getLotteryUserDetail({
      room_id: this._roomId,
      lottery_id: lotteryId,
    });
  }
  // 获取抽奖历史(处理请求状态)
  getLotteryHistory() {
    return lotteryApi.getLotteryHistory({
      show_all: 1
    }).then(res => {
      if (res.code === 200 && res.data && Array.isArray(res.data)) {
        return res.data
      } else {
        console.error('抽奖历史接口异常: ', res)
        return []
      }
    }).catch(err => {
      console.error('抽奖历史接口异常: ', err)
      return []
    })
  }
  // 记录抽奖列表中抽奖的信息
  recordLotteryInfo(id = '') {
    this.state.lotteryLiveId = id
  }
  // 抽奖列表接口（列表、推送、复制、编辑、删除）
  getLotteryLiveList(params) {
    return lotteryApi.lotteryLiveList({
      room_id: this._roomId,
      ...params
    });
  }
  lotteryLiveCope(lotteryId = '') {
    return lotteryApi.lotteryLiveCope({
      lottery_id: lotteryId,
    });
  }
  lotteryLiveDelete(lotteryId = '') {
    return lotteryApi.lotteryLiveDelete({
      lottery_ids: lotteryId,
    });
  }
  lotteryLivePublish(lotteryId = '') {
    return lotteryApi.lotteryLivePublish({
      lottery_id: lotteryId,
    });
  }
  lotteryLiveClose(lotteryId = '', flag) {
    return lotteryApi.lotteryLiveClose({
      lottery_id: lotteryId,
      force_end: flag
    });
  }

  // 发起端获取中奖信息
  getLiveWinnerList(params) {
    return lotteryApi.getLiveWinnerList({
      need_desensitization: 1,
      ...params
    });
  }

  // 条件和用户设置
  // 获取设置信息
  getConditionLiveInfo() {
    return lotteryApi.getConditionLiveInfo({
      webinar_id: this._webinarId,
      lottery_id: this.state.lotteryLiveId,
    });
  }
  // 保存设置信息
  saveConditionLiveInfo(params) {
    return lotteryApi.saveConditionLiveInfo({
      webinar_id: this._webinarId,
      lottery_id: this.state.lotteryLiveId,
      ...params
    });
  }
  // 获取观众用户列表
  getAudienceList(params) {
    const { webinar } = useRoomBaseServer().state.watchInitData;
    return lotteryApi.getAudienceList({
      user_id: webinar.userinfo.user_id,
      is_filter_empty_phone: 2,
      is_require_audience_num: 1,
      ...params
    });
  }
  //检测观众组删除状态
  checkAudienceStatus(params) {
    return lotteryApi.checkAudienceStatus(params);
  }
  //获取在线观众列表
  getOnlineUserList(params) {
    return lotteryApi.getOnlineUserList(params);
  }
  //检查用户是否在线
  checkUserOnline(params) {
    return lotteryApi.checkUserOnline(params);
  }
  // 抽奖页-保存信息
  saveLiveLotteryInfo(params) {
    return lotteryApi.saveLiveLotteryInfo({
      webinar_id: this._webinarId,
      ...params
    });
  }
  // 抽奖页-获取信息
  getLiveLotteryInfo(lotteryId = '') {
    return lotteryApi.getLiveLotteryInfo({
      webinar_id: this._webinarId,
      lottery_id: lotteryId,
    });
  }

  // 领奖页-保存信息
  saveLiveAwardInfo(params) {
    return lotteryApi.saveLiveAwardInfo({
      webinar_id: this._webinarId,
      lottery_id: this.state.lotteryLiveId,
      ...params
    });
  }
  // 领奖页-获取信息
  getLiveAwardInfo() {
    return lotteryApi.getLiveAwardInfo({
      webinar_id: this._webinarId,
      lottery_id: this.state.lotteryLiveId
    });
  }

  // 奖品设置接口
  // 奖品列表
  getLivePrizeList(params) {
    return lotteryApi.getLivePrizeList({
      lottery_id: this.state.lotteryLiveId,
      ...params
    }).then(res => {
      if (res.code === 200 && res.data) {
        // 更新列表总数 (记录直播间奖品数量)
        this.state.prizeTotal = res.data.list.length
      }
      return res
    });
  }
  // 抽奖优惠券列表
  lotteryCouponList(params) {
    return lotteryApi.lotteryCouponList({
      webinar_id: this._webinarId,
      lottery_id: this.state.lotteryLiveId,
      ...params
    })
  }

  // 批量校验优惠券
  checkCoupons(params) {
    return lotteryApi.checkCoupons({
      webinar_id: this._webinarId,
      ...params
    })
  }

  // 资料库奖品列表
  materialPrizeList(params) {
    return lotteryApi.materialPrizeList({
      ...params
    })
  }
  // 优惠券信息列表
  getCouponInfo(params) {
    return lotteryApi.getCouponInfo({
      ...params
    })
  }
  // 抽奖优惠券信息列表
  getListCouponGoods(params) {
    return lotteryApi.getListCouponGoods({
      ...params
    })
  }
  // 奖品复制
  copyLivePrize(id) {
    return lotteryApi.copyLivePrize({
      award_id: id
    });
  }
  // 奖品创建、编辑
  createLivePrize(params) {
    return lotteryApi.createLivePrize({
      room_id: this._roomId,
      lottery_id: this.state.lotteryLiveId,
      ...params
    });
  }
  // 奖品删除
  delLivePrize(params) {
    return lotteryApi.delLivePrize({
      room_id: this._roomId,
      lottery_id: this.state.lotteryLiveId,
      ...params
    });
  }
  // 奖品设置-资料库选择奖品保存按钮
  selectMateriaPrize(params) {
    return lotteryApi.selectMateriaPrize({
      lottery_id: this.state.lotteryLiveId,
      ...params
    });
  }
  // 奖品设置-保存
  saveLivePrizeInfo(params) {
    return lotteryApi.saveLivePrizeInfo({
      lottery_id: this.state.lotteryLiveId,
      ...params
    });
  }

  // 获取抽奖信息
  getReceiveAwardSetting(lotteryId = '') {
    return lotteryApi.getReceiveAwardSetting({
      webinar_id: this._webinarId,
      lottery_id: lotteryId,
    });
  }

  // 初始化按钮状态
  initIconStatus() {
    return this.getLotteryHistory().then(list => {
      if (list.length) {
        // wap icon显示数量+1
        !this.state.iconVisible && this.changeIconShowNum(true)
        this.state.iconVisible = true // 有历史抽奖显示icon
        const lastLottery = list[0] // 倒序排列
        const winLotteryList = list.filter(lot => lot.win === 1 && lot.take_award === 0 && lot.need_take_award === 1) // 中奖且必须领奖,未领奖
        this.state.docVisible = (lastLottery.lottery_status === 0 || winLotteryList.length)
      } else {
        this.state.docVisible = false
      }
      return list
    })
  }

  // 获取抽奖奖品
  getAwardList(id) {
    const params = {
      lottery_id: id,
      pos: 0,
      limit: 20 // 业务的限制一轮奖品最多20
    }
    return lotteryApi.getAwardList(params).then(res => {
      return res?.data?.list || []
    })
  }
  // 获取抽奖的前置条件,(缓存或者接口)
  async getLotteryPrecondition(id) {
    id = `${id}`
    let lotteryTemp = lotteryTempCache.get(id)
    if (lotteryTemp) {
      // 标记过满足条件,或者未有脏值不更新缓存
      if (lotteryTemp.passed || !lotteryTemp.dirty) {
        return lotteryTemp
      }
    }
    lotteryTemp = {}
    let data = {}
    try {
      // 捕获接口异常
      const res = await this.checkPrecondition(id)
      data = res.data
    } catch (e) {}
    if (data.status === 0 || !data.tip) {
      // 满足条件, 或者不可操作且无感知提示
      lotteryTemp.passed = true
      lotteryTemp.dirty = false
    } else {
      lotteryTemp.passed = false
      lotteryTemp.dirty = false
      lotteryTemp.precondition = data
    }
    // 记录缓存中
    lotteryTempCache.set(id, lotteryTemp)
    return lotteryTemp
  }
  // 获取缓存
  getPrecondition(id) {
    id = `${id}`
    return lotteryTempCache.get(id)
  }
  // 设置脏值
  dirtyCache(id) {
    id = `${id}`
    let lotteryTemp = lotteryTempCache.get(id)
    if (lotteryTemp) {
      lotteryTemp.dirty = true
      lotteryTempCache.set(id, lotteryTemp)
    }
  }
  // 完成前置条件
  passPrecondition(id) {
    id = `${id}`
    let lotteryTemp = lotteryTempCache.get(id)
    if (lotteryTemp) {
      lotteryTemp.passed = true
      lotteryTempCache.set(id, lotteryTemp)
    }
  }
  // 接口获取抽奖的前置
  checkPrecondition(id) {
    return lotteryApi.checkPrecondition({
      lottery_id: id
    })
  }
  // change wap右侧展示icon数量
  changeIconShowNum(status) {
    useRoomBaseServer().setShowIconNum(status)
  }
}

export default function useLotteryServer(opt) {
  if (!LotteryServer.instance) {
    LotteryServer.instance = new LotteryServer(opt);
  }
  return LotteryServer.instance;
}
